import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';

class RegisterTelmexTask extends AbstractRequestTask {
    constructor(uri, params = {}) {
        super();
        this.uri = uri;
        this.params = params;
    }

    getParams() {
        const params = super.getParams();
        return Object.assign({}, params, this.params);
    }

    getUrl() {
        return `${this.uri}`;
    }

    success(data, b) {
        this.resolve(data);
    }

    getShowErrorModal(){
        return ENABLE_MODAL_RETRIES;
    }

}

export default RegisterTelmexTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/user/RegisterTelmexTask.js